import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=746579b6&"
import script from "./Points.vue?vue&type=script&lang=js&"
export * from "./Points.vue?vue&type=script&lang=js&"
import style0 from "./Points.vue?vue&type=style&index=0&id=746579b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports